import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxMapLibreGLModule } from '@maplibre/ngx-maplibre-gl';
import type { Map } from 'maplibre-gl';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMapMarker } from '../icons';

import { ApiService } from '../shared/services/api.service';

@Component({
  selector: 'app-order-tracking',
  standalone: true,
  imports: [NgxMapLibreGLModule, FontAwesomeModule],
  templateUrl: './order-tracking.component.html',
  styleUrls: ['./order-tracking.component.scss']
})
export class OrderTrackingComponent implements OnInit {
  faMapMarker = faMapMarker;

  token: string | null = null;
  loaded = false;

  orderLocation?: [number, number];
  deliverer: string;
  refreshInterval: any = null;

  private map?: Map;

  constructor(private route: ActivatedRoute,
              private api: ApiService) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token');
    this.getCoords();
    if(this.refreshInterval)
      clearInterval(this.refreshInterval);

    this.refreshInterval = setInterval(() => {
      this.getCoords();
    }, 5000);
  }

  getCoords() {
    this.api.show('deliveries', `tracking_coords/${this.token}`).subscribe(
      res => {
        const coords = res.coords;
        if(!coords) {
          console.error("OrderTracking::getCoords -> Invalid response: ", res);
          return;
        }
        this.deliverer = res.deliverer;

        const lat = coords.split(";")[0];
        const long = coords.split(";")[1];
        this.orderLocation = [Number(long), Number(lat)];
        if(!this.loaded) {
          this.loaded = true;
        } else {
          this.centerMarker();
        }
      }
    );
  }

  centerMarker() {
    if(!this.loaded)
      return;

    this.map.flyTo({
      center: this.orderLocation,
      zoom: 15,
      pitch: 0,
      bearing: 0,
      essential: true
    });
  }

  // This runs once the map is fully loaded
  onMapLoad(map: Map): void {
    this.map = map;

    // Recenter + zoom smoothly to your marker location
    this.centerMarker();
  }
}
